import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

// Initial state
const initialState = {
  filters: { modalFiltersRules: undefined, modalConditions: undefined },
};
// Actual Slice
export const sellVehiclesSlice = createSlice({
  name: 'sellVehicles',
  initialState,
  reducers: {
    resetModalSellVehiclesSuccess: (state) => {
      state.filters.modalFiltersRules = null;
      state.filters.modalConditions = null;
    },

    changeModalSellVehiclesRulesSuccess: (state, { payload }) => {
      state.filters.modalFiltersRules = payload;
    },

    changeModalSellVehiclesConditionsSuccess: (state, { payload }) => {
      state.filters.modalConditions = payload;
      if (!payload?.rules?.length) {
        state.filters.modalFiltersRules = undefined;
      }
    },

    // Special reducer for hydrating the state. Special case for next-redux-wrapper
    extraReducers: {
      [HYDRATE]: (state, action) => {
        return {
          ...state,
          ...action.payload.errors,
        };
      },
    },
  },
});

export const {
  resetModalSellVehiclesSuccess,
  changeModalSellVehiclesRulesSuccess,
  changeModalSellVehiclesConditionsSuccess,
} = sellVehiclesSlice.actions;

export const selectSellVehiclesState = (state) => state.sellVehicles;

export default sellVehiclesSlice.reducer;

export const resetModalSellVehiclesFilters = () => {
  return async (dispatch) => {
    dispatch(resetModalSellVehiclesSuccess());
  };
};

export const changeModalSellVehiclesFilterRules = (rules) => {
  return async (dispatch) => {
    dispatch(changeModalSellVehiclesRulesSuccess(rules));
  };
};

export const changeModalSellVehiclesFilterConditions = (conditions) => {
  return async (dispatch) => {
    dispatch(changeModalSellVehiclesConditionsSuccess(conditions));
  };
};
